module.exports = __webpack_public_path__ + "static/media/Portrait-10231.e0ea8766.jpg";